/**
 * Client-facing dialogue action contract (mirrors the mobile contract).
 *
 * Info-screen blocks may carry a `primaryAction`/`secondaryAction`. Clients hold
 * an allowlist of action `type`s they can honor. An action block is atomic: if the
 * client cannot honor the primary action type, the whole block (including its
 * action-coupled copy) is skipped and completed conservatively, letting the server
 * route to the safe next block.
 */
export const PREMIUM_UPGRADE_ACTION = 'premium_upgrade';
export const CONTINUE_ACTION = 'continue';

export const SUPPORTED_DIALOGUE_ACTION_TYPES: ReadonlySet<string> = new Set([PREMIUM_UPGRADE_ACTION, CONTINUE_ACTION]);

export function isDialogueActionTypeSupported(type?: string | null): boolean {
  return !!type && SUPPORTED_DIALOGUE_ACTION_TYPES.has(type);
}

/** Result values written to `eventJson[primaryAction.resultKey]`. */
export type DialogueActionResult = 'upgraded' | 'skipped' | 'unsupported';
